<div class="mobile-header">
  <div class="header-grid-mobile">
    @if ((authService.isAuthenticated() | async) === authState.Authenticated) {
      <!-- menu icon -->
      @if (showMenuButton()) {
        <a (click)="openHamburgerMenu()">
          <app-icon alt="Menü" className="mobile-header-icon clickable" src="menu.svg" />
        </a>
      }
      <!-- back button icon -->
      @if (showBackButton()) {
        <div class="clickable">
          <app-back-button />
        </div>
      }
    }
    <a class="site-name" routerLink="/news">
      <app-image
        loading="eager"
        [height]="82"
        [width]="240"
        alt="Wüstenrot Logo"
        src="../../../assets/images/logo.png"
        [priority]="true" />
    </a>
    @if ((authService.isAuthenticated() | async) === authState.Authenticated) {
      <a (click)="openGlobalSearch($event.currentTarget)">
        <app-icon alt="Suchen" className="mobile-header-icon clickable" src="search.svg" />
      </a>
    } @else {
      <div></div>
    }
  </div>
</div>
@if (data | async; as categoriesGroups) {
  <app-hamburger
    [categoriesGroups]="categoriesGroups"
    [categoryGroup]="categoryGroupId"
    (navigationTrigger)="closeHamburgerMenu()" />
}
